import { render, staticRenderFns } from "./ButtonNoBackground.vue?vue&type=template&id=04d5a778&scoped=true&"
import script from "./ButtonNoBackground.vue?vue&type=script&lang=js&"
export * from "./ButtonNoBackground.vue?vue&type=script&lang=js&"
import style0 from "./ButtonNoBackground.vue?vue&type=style&index=0&id=04d5a778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d5a778",
  null
  
)

export default component.exports